<section class="auth-page">
  <div class="auth-panel">
    <div class="brand auth-brand">
      <img class="brand-logo-mark large" src="/img/brand/helipagos-iso-gradient.png" alt="Helipagos">
      <div>
        <strong>Helipagos</strong>
        <span>Cognito Authorization Flow</span>
      </div>
    </div>
    <div>
      <span class="eyebrow">Acceso protegido</span>
      <h2>Redirigiendo a Cognito</h2>
      <p *ngIf="!error">Aguarda un momento...</p>
      <div class="state error" *ngIf="error">{{ error }}</div>
    </div>
    <button class="primary-button wide" type="button" (click)="login()" *ngIf="error">Reintentar</button>
  </div>
</section>
